import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=dd67712a&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&id=dd67712a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67712a",
  null
  
)

export default component.exports